import React, { useEffect, useState } from "react";
import Main from "../../common/Main/Main";
import "./Home.css";
import PropTypes from "prop-types";
//import HomeCard from "./HomeCard";
import Loadspinner from "../../common/Loadspinner";
import HomePageService from "../../services/HomePageService";
import { Redirect } from "react-router-dom";
import useCheckInterestAndExpertise from "../../common/useCheckInterestAndExpertise";
import DataCards2 from "../../common/DataCards2/DataCards2";
import { APICall } from "../../helpers/API/APICalls";
import { getAllPostsQuestions } from "../../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function Home(props) {
  const [loading, setLoading] = useState(false);
  const [allKnowledge, setKnowledgeList] = useState([]);
  const [ismore, setMore] = useState(true);
  const checkInterestAndExpertise = useCheckInterestAndExpertise();



  useEffect(() => {
    //getKnowledgeList(1);
    getKnowledgeNew(1);
  }, []);


  const getKnowledgeList = async (page) => {
    let scrollPosition = getFromEncLocalStorage("position");
    setLoading(true);
    let reqBody = {
      isMyAreaInterest: true,
      limit: 10,
      pageNo: page,
    };

    const res = await HomePageService.getAllKnowledge(reqBody);

    if (res && typeof res[Symbol.iterator] === 'function') {
      if (res.length < 10) {
        setMore(false);
      }
      let data = [...allKnowledge, ...res];
      setKnowledgeList(data);
    }
    if (props.location.state != undefined) {
      window.scrollTo(0, scrollPosition);
    }
    setLoading(false);
  };

  const getKnowledgeNew = async (start) => {
    setLoading(true);
    const employeeNum = getFromEncLocalStorage("employeenumber");
    const reqBody = {
      "start": (start - 1) * 10,
      "resultsPerPage": 10,
      "searchText": "",
      "sortColumn": "",
      "sortDirection": "",
      "userId": employeeNum
    }
    const resp = await APICall(getAllPostsQuestions, reqBody)

    if (resp && resp?.message == "Ok") {
      //console.log(JSON.stringify(resp));
      if (resp?.data?.length < 10) {
        setMore(false);
      }
      let newData = [...allKnowledge, ...resp?.data];
      setKnowledgeList(newData);
    }
    setLoading(false);
  }

  //console.log(allKnowledge)
  const rerender = (val) => {
    //getKnowledgeList(val);
    getKnowledgeNew(val);
  };

  if (checkInterestAndExpertise) {
    return <Redirect to="/profile" />;
  }



  return (
    <Main active={"home"} interestLength={checkInterestAndExpertise ? 1 : 0}>
      <Loadspinner filename="Home.js" isLoading={loading} isMiddle="false" />
      <div className="display-col">
        {/* <HomeCard getCheckedVal={getValue} /> */}
        <DataCards2
          dataList={allKnowledge}
          rerenderParentCallback={rerender}
          ismore={ismore}
        />
      </div>
    </Main>
  );
}

export default Home;

Home.propTypes = {
  location: PropTypes.object,
};
